import { Button, Col, Input, Row, Typography } from "antd";
import "./homepage";
import { EbzHeader } from "./header";
import { HomePage } from "./homepage";
import { ArrowIcon, StopIcon } from "../../shared/utils";
import { useState } from "react";
import { ChatWindow } from "./chatwindow";
import { ChatModel, ChatModelFetch } from "../../shared/axios";
import Lottie from "react-lottie";
import ResponseJson from "../../assets/json/generating response animation.json";
import { v4 as uuid } from "uuid";
import React from "react";
import { getThreadId } from "../../shared/threadIdUtil";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { oneDark } from "react-syntax-highlighter/dist/esm/styles/prism";
import { FaRegCopy } from "react-icons/fa";
import { toast } from "react-toastify";
import PaymentCard from "../PaymentCard";
import { extractTransactionData, jsonTagRegex } from "../utils";
import SpiralLoader from "../spiral-loading";
import Qn2IMG from "../../assets/question-images/cmp5.png";
import Qn3IMG from "../../assets/question-images/cmp6.png";
import Qn1IMG from "../../assets/question-images/cmp7.png";


const { Text } = Typography;

let cardData = {
  id: null,
  amount: null,
  utr: null,
  status: null,
  date: null,
  mode: null,
  paid_to: {
    name: null,
    email: null
  }
};

const data = [
    {
      question: "I need help with products or integrations",
      image: Qn1IMG,
    },
    {
      question: "I need help with transactions or refunds?",
      image: Qn2IMG,
    },
    {
      question: "Help me find the right products for my business",
      image: Qn3IMG,
    },
    // {
    //   question: "What are Easebuzz Products?",
    //   image: Qn1IMG,
    // },
  ];



export const EraV2ChatBot = () => {
  const [isChatting, setIsChatting] = useState(false);
  const [inputQuestion, setInputQuestion] = useState("");
  const [messages, setMessage] = useState([]);
  const [isTypingStopped, setIsTypingStopped] = useState(false);

  const handleCopy = (code) => {
    navigator.clipboard.writeText(code).then(
      () => {
        toast.success("Code copied to clipboard!", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      },
      (err) => {
        toast.error("Failed to copy code. Please try again.", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    );
  };


  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: ResponseJson,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  const handleTypingStopped = () => {
    setIsTypingStopped(true);
    // Set the bot response
    setMessage((pv) => {
      const newFields = [...pv];
      if (
        newFields.length !== 0 &&
        typeof newFields[newFields.length - 1]["content"] == "object"
      ) {
        newFields[newFields.length - 1] = {
          ...newFields[newFields.length - 1],
          content: "",
        };
      }

      return newFields;
    });
  };


  const loadPaymentCard = (cardData, buffer, transactionIdFound = false, isItTransaction = false, isTypingStopped=false) => {
    const { id, amount, utr, status, date, mode, paid_to } = cardData;
      if (isItTransaction) {
        if (transactionIdFound) {
          return (
            <PaymentCard
              id={id}
              amount={amount}
              utr={utr}
              status={status}
              date={date}
              mode={mode}
              paid_to={paid_to}
            >
              {buffer}
            </PaymentCard>
          );
        }
        else if(!isTypingStopped) {
          return (
            <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
              <SpiralLoader content="Fetching information" />
            </div>
          )
        }else{
          return <></>
        }
      }
  }

  // Accpets the feedback and enables the input field
  const handleFeedback = (value, botID) => {
    const updatedData = messages.map((item) => {
      if (item?.bot_id === botID) {
        return {
          ...item,
          feedbackAccepted: [...item["feedbackAccepted"], value],
        }; // Only update matching item
      }
      return item; // Return unchanged item
    });
    setMessage(updatedData);
  };

  // Accpets the typing completed value
  const handleTypingCompleted = (value) => {
    setMessage((pv) => {
      const newFields = [...pv];

      if (
        newFields.length !== 0 &&
        newFields[newFields.length - 1]["typingCompleted"] == null
      ) {
        newFields[newFields.length - 1] = {
          ...newFields[newFields.length - 1],
          typingCompleted: value,
        };
      }
      return newFields;
    });
    setIsTypingStopped(true);
  };

  // Submit the questions and gets the answers
  const handleQuestionSubmitted = async (question) => {
    const newUuid = uuid();
    setInputQuestion("");

    // Set the user question
    setMessage((pv) => [
      ...pv,
      { human_type: "user", content: <>{question}</> },
      {
        bot_id: newUuid,
        human_type: "bot",
        content: (
          <Row>
            <span className="chat-gr-text">Generating response</span>
            <Lottie options={defaultOptions} height={20} width={40} />
          </Row>
        ),
        typingCompleted: null,
      },
    ]);

    setIsChatting(true);
    let thread_id = getThreadId();
    // const response = await ChatModelFetch.submit_question({ question: question },{});
    let hasClearedContent = false;
    let transactionIdFound = false;
    let isItTransaction = false;
    let status = false;
    let buffer = ""
    let tempData = "";
    let chunkList = [];
    const { result } = await ChatModelFetch.era_v2_api(
      { question: question, thread_id: thread_id }, // The question being asked
      {}, // Optional config
      (chunk, done) => {
        chunkList = [...chunkList, chunk]
        
        if ((!tempData.includes("<tran") || /<\s*\/\s*t\s*r\s*a\s*n\s*s\s*a\s*c\s*t\s*i\s*o\s*n\s*-\s*c\s*a\s*r\s*d\s*>/.test(tempData)) && done) {
          buffer = chunkList.join("")
          let found = tempData.match(jsonTagRegex)
          if (found){
            buffer = buffer.replace(`${found[0]}`, '');
          }
        }
        // Handle each chunk as it's received
        setMessage((pv) => {
          const newFields = [...pv];

          if (
            newFields.length !== 0 &&
            newFields[newFields.length - 1]["bot_id"] === newUuid &&
            (typeof newFields[newFields.length - 1]["content"] === "object" ||
              (typeof newFields[newFields.length - 1]["content"] === "string" &&
                newFields[newFields.length - 1]["content"] !== "" &&
                newFields[newFields.length - 1]["typingCompleted"] === false))
          ) {

            const lastContent = newFields[newFields.length - 1]?.content;

            let previousContent = [];

            if (hasClearedContent) {
              if (React.isValidElement(lastContent)) {
                if (lastContent.type === React.Fragment) {
                  const childrenArray = React.Children.toArray(lastContent.props.children);
                  const markdownElement = childrenArray.find(child =>
                    React.isValidElement(child) && child.type === ReactMarkdown
                  );
                  previousContent = markdownElement?.props?.children
                    ? [markdownElement.props.children]
                    : [];
                } else if (lastContent.type === ReactMarkdown) {
                  previousContent = lastContent.props?.children
                    ? [lastContent.props.children]
                    : [];
                } else {
                  previousContent = [];
                }
              } else if (typeof lastContent === "string") {
                previousContent = [lastContent];
              } else {
                previousContent = [];
              }
            }
            hasClearedContent = true;

            const updatedContent = [...previousContent, chunk];
            tempData = chunkList.join("");
            if (!tempData.includes("<tran")) {
              buffer = updatedContent.join("");
              }
            if (tempData.endsWith("this will take about a minute")) {
              isItTransaction = true;
            }
            if (tempData.includes("<transaction-card>")) {
              transactionIdFound = true
            }
            if (!status) {
              const transData = extractTransactionData(tempData);
              cardData = transData[0];
              status = transData[1];
            }
            if (status) {
              transactionIdFound = true;
            }

            newFields[newFields.length - 1] = {
              ...newFields[newFields.length - 1],
              content: (
                <><ReactMarkdown
                  remarkPlugins={[remarkGfm]}
                  components={{
                    a: ({ node, ...props }) => (
                      <a
                        {...props}
                        target="_blank"
                        rel="noopener noreferrer"
                      />
                    ),
                    code({ node, inline, className, children, ...props }) {
                      const match = /language-(\w+)/.exec(className || "");
                      const codeString = String(children).replace(/\n$/, "");
                      return !inline && match ? (
                        <div className="code_window">
                          <SyntaxHighlighter
                            style={oneDark} // Choose your preferred theme
                            language={match[1]} // Extracted language from the className
                            PreTag="div"
                            {...props}
                          >
                            {codeString}
                          </SyntaxHighlighter>
                          <button
                            onClick={() => handleCopy(codeString)}
                            style={{
                              position: "absolute",
                              top: "8px",
                              right: "8px",
                              background: "none",
                              border: "none",
                              cursor: "pointer",
                              color: "white",
                            }}
                            title="Copy to clipboard"
                          >
                            <FaRegCopy size={16} />
                          </button>
                        </div>
                      ) : (
                        <code className={className} {...props}>
                          {children}
                        </code>
                      );
                    },
                  }}
                >
                  {buffer}
                </ReactMarkdown>
                  {loadPaymentCard(cardData, buffer, transactionIdFound, isItTransaction, done)}
                </>

              ),
            };
          }
          return newFields;
        });
      }
    );

    const response = await ChatModel.update_data({ question: question, response: result,thread_id:thread_id });


    setMessage((pv) => {

      const newFields = [...pv];
      if (
        newFields.length !== 0 &&
        newFields[newFields.length - 1]["bot_id"] === newUuid &&
        (typeof newFields[newFields.length - 1]["content"] == "object" ||
          (typeof newFields[newFields.length - 1]["content"] == "string" &&
            newFields[newFields.length - 1]["content"] !== "" &&
            newFields[newFields.length - 1]["typingCompleted"] === false))
      ) {
        newFields[newFields.length - 1] = {
          ...newFields[newFields.length - 1],
          typingCompleted: true,
          // content : result,
          responseID: response.interaction_id, // Add responseID after the stream ends,
          feedbackAccepted: [],
        };
      }

      return newFields;
    });


  };

  // Clears all to Homepage
  const handleClearAll = async () => {
    setIsChatting(false);
    setInputQuestion("");
    setMessage([]);
    setIsTypingStopped(false);
  };

  return (
    <div className="background-container">
      <EbzHeader handleClearAll={handleClearAll} />
      <div className="upper_body">
        {!isChatting ? (
          <HomePage handleQuestionSubmitted={handleQuestionSubmitted} data={data}/>
        ) : (
          <ChatWindow
            chat_messages={messages}
            typingStopped={isTypingStopped}
            handleFeedback={handleFeedback}
            handleTypingCompleted={handleTypingCompleted}
          />
        )}
      </div>
      {/* Input Section  */}
      <div className="prompt">
        <Row className="chat-input-section" align="bottom" justify={"center"}>
          <Col>
            <Row className="box">
              <Input
                className="input-chat-box"
                placeholder="Ask your question..."
                onKeyDown={(ev) => {
                  if (ev.key === "Enter") {
                    ev.preventDefault();
                    let stringValue = ev.target.value.trim();
                    if (stringValue === "") return;
                    if (
                      messages.length === 0 ||
                      messages[messages.length - 1]?.typingCompleted !== null
                    ) {
                      handleQuestionSubmitted(stringValue);
                    }
                  }
                }}
                suffix={
                  messages[messages.length - 1]?.typingCompleted !== null ? (
                    <Button
                      disabled={[null, undefined, ""].includes(inputQuestion)}
                      className="chat-submit-button"
                      onClick={() => handleQuestionSubmitted(inputQuestion)}
                    >
                      <ArrowIcon className="chat-arrow-icon" />
                    </Button>
                  ) : (
                    <Button
                      disabled={!isChatting}
                      className="chat-submit-button"
                      onClick={() => handleTypingStopped()}
                    >
                      <StopIcon />
                    </Button>
                  )
                }
                value={inputQuestion}
                onChange={(e) => {
                  setInputQuestion(e.target.value.trimStart());
                }}
              />
            </Row>
            <Row className="chat-input-lower-div">
              <Text className="chat-input-beta-text">
                ERA is in Beta version.
              </Text>
              <Button
                disabled={!isChatting}
                type="link"
                className="chat-input-clear-all"
                onClick={handleClearAll}
              >
                Clear All
              </Button>
            </Row>
          </Col>
        </Row>
      </div>
    </div>
  );
};
